const siteConfig = {
  loginUrl: '/passport.html#/login',
  indexUrl: '/#/main',
  nullUrl: '/#/404',
}

export default siteConfig